import ApiBase from 'app/services/api/entities/Base'

function* sendEmailShare(data) {
  return yield ApiBase.privatePost('/v1/public/broker_self_service/share_link_send_email/', { data })
}

export default {
  sendEmailShare
}
